import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getData, postData } from './api'
import { UpcomingFollowUpsData, UpcomingFollowUpsState } from './typings'
import { StoreData } from '@user/store/reducers/typings'
import { updateAssigneeIdsNullValue } from '@user/components/Dashboard/widgets/utils/updateAssigneeIdsNullValue'

export const initialState: UpcomingFollowUpsState = {
  assigneeId: null,
  assigneeIds: [],
  data: {
    leadsNextActionDateDue: 0,
    opportunitiesClosingDateDue: 0,
    opportunitiesNextActionDateDue: 0,
    numberOfDays: null,
    salesTeamId: null,
    salesTeamIds: [],
    salesTeamName: null,
    salesTeamNames: null,
    assigneeId: null,
    assigneeIds: [],
    assigneeName: null,
    assigneeNames: null,
    branches: null,
  },
  numberOfDays: 0,
  salesTeamId: null,
  salesTeamIds: [],
  isLoading: false,
  showFront: true,
}

const upcomingFollowUpsSlice = createSlice({
  name: 'dashboard/upcomingFollowUps',
  initialState: initialState,
  reducers: {
    flipCard: (state: UpcomingFollowUpsState) => {
      state.showFront = !state.showFront
    },
    setSalesTeamsIds: (
      state: UpcomingFollowUpsState,
      { payload }: PayloadAction<number[]>,
    ) => {
      state.salesTeamIds = payload
    },
    setAssigneeIds: (
      state: UpcomingFollowUpsState,
      { payload }: PayloadAction<string[]>,
    ) => {
      state.assigneeIds = payload
    },
    setPreferences: (
      state,
      { payload }: PayloadAction<UpcomingFollowUpsData>,
    ) => {
      state.assigneeIds = payload.assigneeIds || []
      state.numberOfDays = payload.numberOfDays || 7
      state.salesTeamId = payload.salesTeamId
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, { payload }) => {
      payload.assigneeIds = updateAssigneeIdsNullValue(payload.assigneeIds)
      state.data = payload
      state.assigneeIds = payload.assigneeIds || []
      state.numberOfDays = payload.numberOfDays || 7
      state.salesTeamId = payload.salesTeamId
      state.salesTeamIds = payload.salesTeamIds
    })
    builder.addCase(postData.fulfilled, (state, { payload }) => {
      state.assigneeId = payload.assigneeId
      state.salesTeamId = payload.salesTeamId
      state.numberOfDays = payload.numberOfDays || 7
    })
  },
})

export const selectUpcomingFollowUps = (state: StoreData) => {
  return state.dashboard.upcomingFollowUps
}

export const { flipCard, setPreferences, setSalesTeamsIds, setAssigneeIds } =
  upcomingFollowUpsSlice.actions
export const reducer = upcomingFollowUpsSlice.reducer
